import { Card } from 'primereact/card';
import './newCPPRequest.scss';
import imgone from '../../assets/CreateClientMain.svg';
import imgtwo from '../../assets/CreateProgramMain.svg';
import imgthree from '../../assets/CreateProjectMain.svg';
import { useState } from 'react';
import { NEWCLIENTREQUEST, NEWPROGRAMREQUEST, NEWPROJECTREQUEST } from '../../constants';
import { useNavigate } from "react-router-dom";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export const NewCPPRequest = (props : any) =>
{
    const navigate = useNavigate();
    const headerone = (
        <img alt="Create a Client" className='clsimg' src={imgone} />
    );
    
    const headertwo = (
        <img alt="Create a Client" className='clsimg' src={imgtwo} />
    );

    const headerthree = (
        <img alt="Create a Client" className='clsimg' src={imgthree} />
    );

    function createclient()
    {
      navigate(NEWCLIENTREQUEST);
    }
 
    function createprogram()
    {
      navigate(NEWPROGRAMREQUEST);
    }

    function createproject()
    {
      navigate(NEWPROJECTREQUEST);
    }

    return <>
     <div className="row m-5 mt-4 divCardParent"><h4>New CPP Request</h4>
    <Card title="What would you like to do?">
      { props.isCodeCreation &&
        <Card subTitle="Create a Client" header={headerone} className="divCardChild" onClick={createclient}></Card>
      }
        { props.isGAGroup &&
        <>
        <Card subTitle="Create a Program" header={headertwo} className="divCardChild" onClick={createprogram}></Card>
        <Card subTitle="Create a Project" header={headerthree} className="divCardChild" onClick={createproject}></Card>
        </>}
    </Card>
    </div>
    </>
}